import React from 'react';
import PropTypes from 'prop-types';
import Icons from '../Icons';
import * as S from './styled';

const ICON_COLOR = {
  selected: 'var(--rounded-grid-card-accent)',
  idle: 'var(--rounded-grid-card-color)'
};

export const ThemeSwitcher = ({ value, onChange, lightLabel, darkLabel, testId }) => {
  const options = [
    { value: 'light', Icon: Icons.Sun, label: lightLabel },
    { value: 'dark', Icon: Icons.Moon, label: darkLabel }
  ];

  return (
    <S.Track data-testid={testId} role="radiogroup">
      {options.map(({ value: optionValue, Icon, label }) => {
        const selected = optionValue === value;
        return (
          <S.Option
            key={optionValue}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={label}
            data-testid={`${testId}-${optionValue}`}
            $selected={selected}
            onClick={() => !selected && onChange?.(optionValue)}>
            <Icon tooltip={label} color={selected ? ICON_COLOR.selected : ICON_COLOR.idle} />
          </S.Option>
        );
      })}
    </S.Track>
  );
};

ThemeSwitcher.propTypes = {
  value: PropTypes.oneOf(['light', 'dark']).isRequired,
  onChange: PropTypes.func,
  lightLabel: PropTypes.string.isRequired,
  darkLabel: PropTypes.string.isRequired,
  testId: PropTypes.string
};
